import AlertRegular from 'mini-fluent-svg-icons/lib/icons/AlertRegular';
import AlertUnreadRegular from 'mini-fluent-svg-icons/lib/custom-icons/AlertUnreadRegular';
import strings from 'owa-strings/owa-mini-strings';
import { areUnseenItemsPresent } from 'mini-activity-pane-store/lib/selectors/areUnseenItemsPresent';
import { HeaderIconType } from 'mini-header';
import { onActivityIconClick } from '../utils/onActivityIconClick';

export function getActivityIcon(): HeaderIconType {
    const areNewNotificationsPresent = areUnseenItemsPresent();

    return {
        icon: areNewNotificationsPresent ? AlertUnreadRegular : AlertRegular,
        ariaLabel: areNewNotificationsPresent
            ? strings.activityNotificationsAriaLabel
            : strings.activityIconAriaLabel,
        onClick: onActivityIconClick,
    };
}
